import { Action } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import * as Objects from '@core/objects';


export enum SettingsWorkflowsActionType {
    // PERSISTED WORKFLOWS ACTIONS
    LoadWorkflows = "[SettingsWorkflows] GET - Obtain all persisted workflows ",
	LoadWorkflowsSuccess = "[SettingsWorkflows] - Obtain all persisted workflows SUCCESS",
	LoadWorkflowsError = "[SettingsWorkflows] -Obtain all persisted workflows ERROR",

    LoadTransitions = "[SettingsWorkflows] GET - Obtain all persisted workflow transitions ",
    LoadTransitionsSuccess = "[SettingsWorkflows] GET - Obtain all persisted workflow transitions SUCCESS",
    LoadTransitionsError = "[SettingsWorkflows] GET - Obtain all persisted workflow transitions ERROR",

    // EDITING ACTIONS

    SaveTransitions = "[SettingsWorkflows] POST - Save workflow transitions",
    SaveTransitionsSuccess = "[SettingsWorkflows] POST - Save workflow transitions SUCCESS",
    SaveTransitionsError = "[SettingsWorkflows] POST - Save workflow transitions ERROR",

	ClearWorkflowEditor = "[SettingsWorkflows] - clear editing workflow"

}

// Load persisted workflows list
export class LoadWorkflows implements Action {
    readonly type = SettingsWorkflowsActionType.LoadWorkflows;
    constructor() {}
}

export class LoadWorkflowsSuccess implements Action {
    readonly type = SettingsWorkflowsActionType.LoadWorkflowsSuccess;
    constructor(public workflows: Array<Objects.Workflow>) {}
}

export class LoadWorkflowsError implements Action {
    readonly type = SettingsWorkflowsActionType.LoadWorkflowsError;
    constructor(public error: HttpErrorResponse) {}
}

// Request Status Transitions
export class LoadTransitions implements Action {
    readonly type = SettingsWorkflowsActionType.LoadTransitions;
    constructor(public workflowId: number) {}
}

export class LoadTransitionsSuccess implements Action {
    readonly type = SettingsWorkflowsActionType.LoadTransitionsSuccess;
    constructor(public transitions: Array<Objects.WorkflowTransition>) {}
}

export class LoadTransitionsError implements Action {
    readonly type = SettingsWorkflowsActionType.LoadTransitionsError;
    constructor(public error: HttpErrorResponse) {}
}

export class ClearWorkflowEditor implements Action {
    readonly type = SettingsWorkflowsActionType.ClearWorkflowEditor;
    constructor() {}
}
// updating and saving

export class SaveTransitions implements Action {
    readonly type = SettingsWorkflowsActionType.SaveTransitions;
    /**
     * 
     * @param transitions is not an object WorkflowTransitions, it is an interface WorkflowEditorOutput 
     * @param id 
     */
    constructor(public transitions, public id: number) {}
}

export class SaveTransitionsSuccess implements Action {
    readonly type = SettingsWorkflowsActionType.SaveTransitionsSuccess;
    constructor(public transitions: Array<Objects.WorkflowTransition>) {}
}

export class SaveTransitionsError implements Action {
    readonly type = SettingsWorkflowsActionType.SaveTransitionsError;
    constructor(public error: HttpErrorResponse) {}
}


export type SettingsWorkflowsActions = 	LoadWorkflows |
                                        LoadWorkflowsSuccess |
                                        LoadWorkflowsError |

                                        LoadTransitions |
                                        LoadTransitionsSuccess |
                                        LoadTransitionsError |

                                        SaveTransitions |
                                        SaveTransitionsSuccess |
                                        SaveTransitionsError |

                                        ClearWorkflowEditor;



